
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'

@Options({
    computed: {
        ...mapState(['userInfo', 'aid', 'activityData'])
    },
    data() {
        return {
            isApp: false,
            list: [1, 2, 3, 4, 5, 6, 7, 8],
            textCount: {
                total: 0,
                surplus: 0,
            },
        }
    },
    mounted() {
        this.getCount()

        this.isApp = COVERAPP.Attribute.isApp()

        this.$common.pageLoaded()
        this.$common.track('load', '进入福字集市页')
    },
    methods: {
        ...mapMutations(["SET_DIALOGDATA"]),
        goSelect() {
            this.$router.push('/select1')
        },
        goRecordFu() {
            this.$router.push('/recordfu')
        },
        goDetail(index: number) {
            this.$router.push({
                path: '/detail',
                query: {
                    index
                }
            })
        },
        getCount() {
            this.$request('/temporary/2023redpack/count', {
                aid: this.aid,
                userinfo: this.userInfo,
            }, 'post').then((data: any) => {
                this.textCount = {
                    total: data.total,
                    surplus: data.surplus,
                }
            }).catch((err: any) => {
                this.$toast(err.errmsg || '出错了')
            })
        },
    }
})
export default class Market extends Vue { }
